import type { IconData } from '@stacksjs/iconify-core'

export const at1x1: IconData = {
  "body": "<path fill=\"#fff\" d=\"M0 170.7h512v170.6H0z\"/><path fill=\"#c8102e\" d=\"M0 0h512v170.7H0zm0 341.3h512V512H0z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default at1x1
